<div class="vq-dialog" role="dialog" aria-labelledby="avq-title">
  <div class="vqd-head">
    <div class="t">
      <h2 id="avq-title">Apply Vendor Quotes to Scope</h2>
      <p>Click a quote. We match its items to the materials in <b>{{ scopeLabel }}</b> and show you every change first.</p>
    </div>
    <button type="button" class="vqd-x" (click)="cancel()" aria-label="Close"><mat-icon>close</mat-icon></button>
  </div>

  <div class="vqd-body">
    @if (hasExpired) {
      <div class="vqd-switch">
        <span class="t">
          <b>Include expired quotes</b>
          <span class="s">{{ allowExpired ? 'Expired quotes can be picked. Confirm their prices with the vendor.' : 'Turn on to pick a quote that has passed its valid-till date.' }}</span>
        </span>
        <mat-slide-toggle class="b-one-switch" [checked]="allowExpired" (change)="setAllowExpired($event.checked)"
          aria-label="Include expired quotes"></mat-slide-toggle>
      </div>
    }

    <!-- G1: one option per quote on the bid — a click opens Compare for that quote -->
    @for (q of quotes; track trackByQuote($index, q)) {
      <div class="opt" [class.pick]="canPick(q)" [class.sel]="lastPicked === q.quoteId && canPick(q)" [class.dis]="!canPick(q) && !appliedTo(q.quoteId)" [class.app]="!!appliedTo(q.quoteId)"
        [matTooltip]="blockedReason(q) || (canPick(q) ? 'Compare this quote with your materials' : '')"
        [attr.role]="canPick(q) ? 'button' : null" [attr.tabindex]="canPick(q) ? 0 : null"
        [attr.aria-label]="'Compare ' + q.vendorName + ' ' + q.quotationReference"
        (click)="pick(q)" (keydown.enter)="pick(q)" (keydown.space)="$event.preventDefault(); pick(q)">
        <mat-icon class="oi">{{ appliedTo(q.quoteId) ? 'check_circle' : 'request_quote' }}</mat-icon>
        <span class="t">
          <b>{{ q.vendorName }}</b> <span class="muted">· {{ q.quotationReference }}</span>
          <span class="s">
            @if (q.isExpired) {
              <span class="vqd-tag exp">Expired {{ formatDate(q.validTill) }}</span>
            } @else {
              Valid till {{ formatDate(q.validTill) }}
            }
            · covers <b>{{ covers(q) }} of {{ materialCount }}</b> materials
            @if (adds(q)) { · adds {{ adds(q) }} new }
            @if (unpricedCount(q)) { · <span class="vqd-tag nop">{{ unpricedCount(q) }} without a price</span> }
          </span>
        </span>
        <span class="pr"><b class="num">{{ q.total | currency }}</b><span class="s">{{ plural(q.items.length, 'item') }}</span></span>

        <!-- Applied to this scope (whole quote) / used on single lines — each with its own Undo -->
        @if (appliedTo(q.quoteId); as row) {
          <span class="vqd-applied">
            <span class="vqd-tag ok" matTooltip="Already applied to this scope, so it can't be picked again. Undo it to apply it again."><mat-icon>check_circle</mat-icon>Applied</span>
            <span class="w">{{ appliedWhen(row) }}@if (appliedWith(row, q.quoteId); as with_) { <span> · together with {{ with_ }}</span> }</span>
            <span class="sp"></span>
            <ng-container *ngTemplateOutlet="undoBtn; context: { $implicit: row, quoteId: q.quoteId }"></ng-container>
          </span>
        }
        @for (row of usedOn(q.quoteId); track row.id) {
          <span class="vqd-applied">
            <span class="vqd-tag use"><mat-icon>link</mat-icon>Used on</span>
            <span class="w"><b>{{ row.lines.join(', ') || 'one material' }}</b> {{ appliedWhen(row) }}</span>
            <span class="sp"></span>
            <ng-container *ngTemplateOutlet="undoBtn; context: { $implicit: row }"></ng-container>
          </span>
        }
      </div>
    }

    <!-- Applies whose quote is no longer on the list (deleted, or off the bid) — still undoable -->
    @for (row of otherApplications; track row.id) {
      <div class="opt dis vqd-orphan">
        <mat-icon class="oi">history</mat-icon>
        <span class="t"><b>{{ row.label }}</b><span class="s">Applied {{ appliedWhen(row) }} · this quote is no longer on the list</span></span>
        <ng-container *ngTemplateOutlet="undoBtn; context: { $implicit: row }"></ng-container>
      </div>
    }

    <ng-template #undoBtn let-row let-quoteId="quoteId">
      <!-- Tooltip on a wrapper: a disabled button never shows its own. Clicks and keys stop here so they
           never reach the quote row, which would open Compare. -->
      <span class="vqd-undo-w" [matTooltip]="undoTooltip(row, quoteId)" (click)="$event.preventDefault(); $event.stopPropagation()"
        (keydown.enter)="$event.stopPropagation()" (keydown.space)="$event.stopPropagation()">
        <button type="button" class="vqd-undo" [disabled]="!row.canUndo || (undoingId !== null)" (click)="undoApplication(row, $event)"
          [attr.aria-label]="'Undo ' + row.label">
          @if (undoingId === row.id) {
            <mat-icon class="spin">autorenew</mat-icon>Undoing…
          } @else {
            <mat-icon>undo</mat-icon>Undo
          }
        </button>
      </span>
    </ng-template>

    @if (!quotes.length) {
      <div class="vqd-tip"><mat-icon>info</mat-icon><span class="t">There are no vendor quotes on this bid yet.</span></div>
    }

  </div>

  <!-- G3 -->
  <div class="vqd-foot">
    <span class="note">Click a quote to see exactly what will change. Nothing changes yet.</span>
    <button type="button" class="vqd-btn" (click)="cancel()">Cancel</button>
  </div>
</div>
